import { RootState } from "../../../app/store";
import { UiAddress, UiRegion } from "@pages/makeEvent/slice/MakeEventSlice.ts";
import { EventPrivateSelect } from "@pages/makeEvent/steps-components/eventMode-component/types.ts"
import { EventTypeSelection } from '@pages/makeEvent/steps-components/eventType-component/types.ts'

export const selectDialog = (state: RootState): boolean =>
  state.eventDialog.showEvent
export const selectRegion = (state: RootState): UiRegion | undefined => state.eventDialog.region
export const selectAddress = (state: RootState): UiAddress | undefined => state.eventDialog.address
export const selectEventMode = (state: RootState): EventPrivateSelect | undefined => state.eventDialog.eventModePrivate
export const selectEventType = (state: RootState): EventTypeSelection | undefined => state.eventDialog.eventType